import * as classes from "./expanded-menu.module.scss";
import content from "../../content.json";
import classNames from "classnames";
import { useContext, useEffect } from "react";
import {
  ActionType,
  AppContext,
  ModalType,
  ViewMode,
  World,
} from "../../contexts/AppContext";
import Button from "../Button/Button";

const ExpandedMenu = () => {
  const { state, dispatch } = useContext(AppContext);
  const { viewMode, world, isMenuOpen } = state;

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        dispatch({ type: ActionType.ToggleMenu });
      }
    };
    if (isMenuOpen) {
      window.addEventListener("keydown", onKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isMenuOpen]);

  return (
    <div
      className={classNames(classes.root, {
        [classes["root--is-visible"]]: isMenuOpen,
      })}
      aria-hidden={!isMenuOpen}
    >
      <Button
        className={classes.close}
        type="button"
        label="Close"
        onClick={() => dispatch({ type: ActionType.ToggleMenu })}
      />
      <Button
        className={classes.shop}
        type="link"
        href={content.shopUrl}
        label="Shop now"
        size="large"
        style="outline"
      />
      <button
        className={classes.item}
        onClick={() => {
          if (world !== World.FieldTrip) {
            dispatch({
              type: ActionType.SetWorld,
              value: World.FieldTrip,
            });
          }
          dispatch({ type: ActionType.ToggleMenu });
        }}
      >
        Zone 1: Field Trip
      </button>
      <button
        className={classes.item}
        onClick={() => {
          if (world !== World.CoralLagoon) {
            dispatch({
              type: ActionType.SetWorld,
              value: World.CoralLagoon,
            });
          }
          dispatch({ type: ActionType.ToggleMenu });
        }}
      >
        Zone 2: Coral Lagoon
      </button>
      <button
        className={classes.item}
        onClick={() => {
          if (world !== World.FungiForest) {
            dispatch({
              type: ActionType.SetWorld,
              value: World.FungiForest,
            });
          }
          dispatch({ type: ActionType.ToggleMenu });
        }}
      >
        Zone 3: Fungi Forest
      </button>
      <button
        className={classes.item}
        onClick={() => {
          dispatch({
            type: ActionType.SetViewMode,
            value: ViewMode.Lookbook,
          });
          dispatch({ type: ActionType.ToggleMenu });
        }}
      >
        Lookbook
      </button>
      <br />
      <br />
      {content.menuLinks.map(({ url, label }) => (
        <a
          className={classes.item}
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      ))}
    </div>
  );
};
export default ExpandedMenu;
